// src/components/ServersParser/ServersParserTips.jsx
import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const ServersParserTips = () => {
  const { language } = useLanguage();
  const isEn = language === 'en';

  const tips = [
    {
      title: isEn ? 'Search Strategies' : 'Стратегии поиска',
      desc: isEn ? (
        <>Searching by <strong>vulnerabilities</strong> discovers servers with known security flaws, while searching by <strong>parameters</strong> finds targets matching specific specs.</>
      ) : (
        <>Поиск по <strong>уязвимостям</strong> находит серверы с известными проблемами безопасности, в то время как поиск по <strong>параметрам</strong> позволяет находить серверы с определенными характеристиками.</>
      ),
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" />
          <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76" />
        </svg>
      )
    },
    {
      title: isEn ? 'Vulnerability Levels' : 'Уровни уязвимости',
      desc: isEn ? (
        <><strong>Low level</strong> finds servers with basic flaws, <strong>medium</strong> with more serious issues, and <strong>high</strong> with critical security vulnerabilities.</>
      ) : (
        <><strong>Низкий уровень</strong> находит серверы с базовыми уязвимостями, <strong>средний</strong> — с более серьезными проблемами, а <strong>высокий</strong> — с критическими уязвимостями.</>
      ),
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          <line x1="12" y1="8" x2="12" y2="12" />
          <line x1="12" y1="16" x2="12.01" y2="16" />
        </svg>
      )
    },
    {
      title: isEn ? 'Use Filters' : 'Используйте фильтры',
      desc: isEn ? (
        <>Filters by <strong>player count</strong> and <strong>Minecraft server version</strong> help narrow your search down to the exact targets you need.</>
      ) : (
        <>Фильтры по <strong>количеству игроков</strong> и <strong>версии сервера</strong> помогают сузить поиск до нужных вам серверов.</>
      ),
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
          <line x1="4" x2="20" y1="12" y2="12" />
          <line x1="4" x2="20" y1="6" y2="6" />
          <line x1="4" x2="20" y1="18" y2="18" />
          <circle cx="8" cy="6" r="2" />
          <circle cx="16" cy="12" r="2" />
          <circle cx="10" cy="18" r="2" />
        </svg>
      )
    }
  ];

  return (
    <section className="pro-tips-section">
      <div className="pro-tips-heading">
        <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.8">
          <circle cx="12" cy="12" r="10" />
          <circle cx="12" cy="12" r="3" fill="currentColor" />
        </svg>
        <span>
          {isEn
            ? 'PARSER RECOMMENDATIONS • PRO TIPS'
            : 'РЕКОМЕНДАЦИИ ПО ПАРСИНГУ • PRO TIPS'}
        </span>
      </div>

      <div className="tips-grid">
        {tips.map((tip, idx) => (
          <div key={idx} className="tip-card">
            {/* Фоновая векторная иконка за плашкой */}
            <div className="tip-backdrop-icon" aria-hidden="true">
              {tip.icon}
            </div>

            <div className="tip-card-inner">
              <div className="tip-icon-header">
                {tip.icon}
              </div>
              <h4 className="tip-title">{tip.title}</h4>
              <p className="tip-description">{tip.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ServersParserTips;
